import React from 'react';
import PropTypes from 'prop-types';
import symbols from './symbol-defs.svg';
import classnames from 'classnames';
import styles from './icon.scss';

const Icon = ({ name, circle, className, color, opacity, textPosition }) => {
  const icon = <svg className={classnames(className, styles[name], styles[color], styles[`pos-${textPosition}`], {[styles.inText]: textPosition})} fillOpacity={opacity} width="1em" height="1em"><use xlinkHref={symbols + "#" + name} /></svg>

  if (circle) {
    return (
      <div className={styles.circle}>
        {icon}
      </div>
    );
  }
  
  return icon;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  circle: PropTypes.bool,
  color: PropTypes.string,
  textPosition: PropTypes.string,
};

export { Icon };



// WEBPACK FOOTER //
// ./src/elements/icon/icon.js